import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player'
// import { Typewriter } from 'react-simple-typewriter'
import Thumbnail from './../../../public/home/thumbnail.webp';
import Dots from './../../../public/home/dots.webp';
import { hostEventUrl, mediaUrl } from '../../config/config';
// import { adminUrl, blobAccount } from './../../config/config';
import Image from 'next/future/image'


const HomeHeader = () => {

    const [playing, setPlaying] = useState(false);

    const videoRef = useRef(false)
    return (
        <>
            <div className="row home-header-container px-md-5 px-3 pt-3 pb-0 g-0 flex-column">
                <div className="col pb-md-3 pt-md-5 px-md-3 py-3 px-3 header-title-container text-center">
                    <h1 className="header-title text-center d-inline-block">
                        Make Your Events<br />
                        <span className="theme">
                            Engaging
                        </span>
                        {" "}&{" "}
                        <span className="theme">
                            Effective
                        </span>
                        !
                        <div className="dots-1"></div>
                        <div className="dots-2"></div>
                    </h1>
                    <div className="sub-text pt-4 mx-auto pb-4 text-center">One-stop ticketing & event management platform for online, hybrid and in-person events.
                        We help you drive the right audience & make your event more successful.</div>
                    <div className="py-3 text-center">
                        <a href="https://calendly.com/tanvi-konfhub/konfhub-quizhub-walk-through" target="_blank" rel="noreferrer">
                            <button className="btn btn-header mb-lg-2 mb-2 mb-sm-0 btn-demo">
                                Schedule Demo&nbsp;
                                <i className="fas fa-chevron-circle-right arrow"></i>
                            </button>
                        </a>
                        <a href={`${hostEventUrl}/create/event`} target="_blank" rel="noreferrer">
                            <button className="btn btn-header mb-lg-2 ms-0 ms-lg-5 ms-sm-3">
                                Host an Event&nbsp;
                                <i className="fas fa-chevron-circle-right arrow"></i>
                            </button>
                        </a>
                    </div>
                </div>
                <div className="col py-md-3 px-md-5 py-3">
                    <div className="mx-md-5 px-md-3">
                        <ReactPlayer
                            ref={videoRef}
                            url={`${mediaUrl}/kh-product-demo.mp4`}
                            controls
                            width="100%"
                            height="100%"
                            style={{
                                background: '#572148',
                                border: '5px solid #FFFFFF',
                                boxShadow: '4px 4px 30px rgba(0, 0, 0, 0.25)',
                                borderRadius: '5px',
                                padding: '15px',
                                display: 'flex',
                                position: 'relative'
                            }}
                            pip
                            light={<Image src={Thumbnail} style={{objectFit: "contain"}} alt='KonfHub Dashboard' className="w-100 h-100" width={1200} height={675}/>}
                            playing={playing}
                            playIcon={<></>}
                            onEnded={() => {
                                videoRef.current.showPreview();
                                setPlaying(false);
                            }}
                            onClickPreview={() => {
                                setPlaying(true);
                            }}
                            onStart={() => {
                                setPlaying(true);
                            }}
                            onPause={() => {
                                setPlaying(false);
                            }}
                            onPlay={(e) => {
                                setPlaying(true);
                            }}
                        />
                    </div>
                </div>
                <div className="col py-md-3 px-md-5 py-3 d-flex justify-content-center align-items-center flex-md-row flex-column">
                    <div className="d-md-inline-flex d-flex flex-column justify-content-center align-items-center py-3 px-5">
                        <div className="stars">
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star-half-stroke" />
                        </div>
                        <a href="https://www.capterra.com/p/265126/KonfHub/" target="_blank" rel="noreferrer">
                            <div className="star-title">4.8/5 <b>Capterra</b></div>
                        </a>
                    </div>
                    <div className="d-md-inline-flex d-flex flex-column justify-content-center align-items-center py-3 px-5">
                        <div className="stars">
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star-half-stroke" />
                        </div>
                        <a href="https://www.softwareadvice.com/ticketing/konfhub-profile/reviews/" target="_blank" rel="noreferrer">
                            <div className="star-title">4.7/5 <b>Software Advice</b></div>
                        </a>
                    </div>
                    <div className="d-md-inline-flex d-flex flex-column justify-content-center align-items-center py-3 px-5">
                        <div className="stars">
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star-half-stroke" />
                        </div>
                        <a href="https://www.getapp.com/customer-management-software/a/konfhub/" target="_blank" rel="noreferrer">
                            <div className="star-title">4.8/5 <b>GetApp</b></div>
                        </a>
                    </div>
                </div>
            </div>
            <style>{`
        .home-header-container {
            background-color: #F6F9FC;
            color: #572148;
        }

        .home-header-container .header-title-container {

        }

        .home-header-container .header-title {
            background: url(${Dots}) 1em em norepeat, url(${Dots}) 70% 40% norepeat;
            font-family: "Poppins", "Prompt";
            font-style: normal;
            font-weight: 700;
            font-size: 70px;
            line-height: 91px;
            position: relative;
        }
        .header-title{
            font-family: 'Poppins' !important;
        }

        .home-header-container .header-title .dots-1 {
            background: url(${Dots}) no-repeat;
            width: 130px;
            height: 96px;
            position: absolute;
            top: -8px;
            left: -54px;
            background-size: cover;
        }

        .home-header-container .header-title .dots-2 {
            background: url(${Dots}) no-repeat;
            width: 130px;
            height: 96px;
            position: absolute;
            bottom: -16px;
            right: -5px;
            background-size: cover;
        }

        .home-header-container .header-title .theme {
            color: #FB5850;
        }

        .home-header-container .sub-text-title {
            font-family: 'Nunito';
            font-weight: 700;
            font-size: 28px;
            line-height: 32px;
            color: #572148;
        }

        .home-header-container .sub-text {
            font-family: 'Nunito';
            font-style: normal;
            width: 70%;
            font-weight: 500;
            font-size: 22px;
            line-height: 140%;
            color: #525252;
        }

        .home-header-container .video-wrapper {
            background: #572148;
            border: 5px solid #FFFFFF;
            box-shadow: 4px 4px 30px rgba(0, 0, 0, 0.25);
            border-radius: 5px;
        }

        .home-header-container .stars i {
            margin: 0 5px;
        }

        .home-header-container .star-title {
            font-family: 'Nunito';
            color: #572148;
        }
        a{
            text-decoration: none;
        }

        /* MD screens */
        @media only screen and (min-width: 768px) and (max-width: 992px) {

        }

        /* SM screens */
        @media only screen and (min-width: 480px) and (max-width: 768px) {
            .home-header-container .header-title {
                font-size: 40px;
                line-height: 50px;
            }

            .home-header-container .sub-text {
                font-size: 16px;
                line-height: 24px
            }
        }

        /* XS screens */
        @media only screen and (max-width: 480px) {
            .home-header-container .header-title {
                font-size: 40px;
                line-height: 50px;
            }

            .home-header-container .sub-text {
                font-size: 16px;
                line-height: 24px
            }
        }
    `}</style>
        </>
    )
}

export default HomeHeader
